import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Token_NULL_getInstance2d65is50ce53 as Token_NULL_getInstance } from '../json/JsonReader.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  falseVariables32gd1w4dsf9iv as falseVariables,
  parseData1xjh6qzzvft3n as parseData,
} from '../Executables.mjs';
import { readAny17j2jqaxubdko as readAny } from '../json/JsonReaders.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { JsonDataException2rdtm884tky1l as JsonDataException } from '../../exception/Exceptions.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Builder16nv925388a0q as Builder } from '../ApolloResponse.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  Builder3gaff1pwujyid as Builder_0,
  Location25t453jk43ktl as Location,
} from '../Error.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readErrors(_this__u8e3s4) {
  if (_this__u8e3s4.peek_21nx7_k$().equals(Token_NULL_getInstance())) {
    _this__u8e3s4.nextNull_njy9ei_k$();
    return emptyList();
  }
  _this__u8e3s4.beginArray_hxn19s_k$();
  // Inline function 'kotlin.collections.mutableListOf' call
  var list = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  while (_this__u8e3s4.hasNext_bitz1p_k$()) {
    list.add_utx5q5_k$(readError(_this__u8e3s4));
  }
  _this__u8e3s4.endArray_s2tmpq_k$();
  return list;
}
var ResponseParserClass;
function ResponseParser() {
  if (ResponseParserClass === VOID) {
    class $ {
      parse_t0woe3_k$(jsonReader, operation, requestUuid, customScalarAdapters, deferredFragmentIds) {
        jsonReader.beginObject_5wddq0_k$();
        var data = null;
        var errors = null;
        var extensions = null;
        while (jsonReader.hasNext_bitz1p_k$()) {
          var name = jsonReader.nextName_njxula_k$();
          switch (name) {
            case 'data':
              var falseVariables_0 = falseVariables(operation, customScalarAdapters);
              data = parseData(operation, jsonReader, customScalarAdapters, falseVariables_0, deferredFragmentIds, errors);
              break;
            case 'errors':
              errors = readErrors(jsonReader);
              break;
            case 'extensions':
              var tmp = readAny(jsonReader);
              extensions = (!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : null;
              break;
            default:
              if (!jsonReader.ignoreUnknownKeys_scm7n0_k$()) {
                throw JsonDataException().new_com_apollographql_apollo_exception_JsonDataException_fxccxn_k$("Unknown key '" + name + "' found at path: '" + joinToString(jsonReader.getPath_18su3p_k$(), '.') + "'");
              }

              jsonReader.skipValue_18u2ci_k$();
              break;
          }
        }
        jsonReader.endObject_ofuv3u_k$();
        return Builder().new_com_apollographql_apollo_api_ApolloResponse_Builder_h8chhh_k$(operation, requestUuid == null ? uuid4() : requestUuid).errors_tmpwze_k$(errors).data_25r92p_k$(data).extensions_sh2glh_k$(extensions).build_1k0s4u_k$();
      }
    }
    initMetadataForObject($, 'ResponseParser');
    ResponseParserClass = $;
  }
  return ResponseParserClass;
}
var ResponseParser_instance;
function ResponseParser_getInstance() {
  return ResponseParser_instance;
}
function readError(_this__u8e3s4) {
  var message = '';
  var locations = null;
  var path = null;
  var extensions = null;
  var nonStandardFields = null;
  _this__u8e3s4.beginObject_5wddq0_k$();
  while (_this__u8e3s4.hasNext_bitz1p_k$()) {
    var name = _this__u8e3s4.nextName_njxula_k$();
    switch (name) {
      case 'message':
        var tmp0_elvis_lhs = _this__u8e3s4.nextString_kwkc9o_k$();
        message = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
        break;
      case 'locations':
        locations = readErrorLocations(_this__u8e3s4);
        break;
      case 'path':
        path = readPath(_this__u8e3s4);
        break;
      case 'extensions':
        var tmp = readAny(_this__u8e3s4);
        extensions = (tmp == null ? true : isInterface(tmp, KtMap())) ? tmp : null;
        break;
      default:
        if (!_this__u8e3s4.ignoreUnknownKeys_scm7n0_k$()) {
          throw JsonDataException().new_com_apollographql_apollo_exception_JsonDataException_fxccxn_k$("Unknown key '" + name + "' found at path: '" + joinToString(_this__u8e3s4.getPath_18su3p_k$(), '.') + "'");
        }

        if (nonStandardFields == null) {
          // Inline function 'kotlin.collections.mutableMapOf' call
          nonStandardFields = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        }

        var tmp0 = nonStandardFields;
        // Inline function 'kotlin.collections.set' call

        var value = readAny(_this__u8e3s4);
        tmp0.put_4fpzoq_k$(name, value);
        break;
    }
  }
  _this__u8e3s4.endObject_ofuv3u_k$();
  return (new (Builder_0())(message)).locations_dffcqo_k$(locations).path_rwdaoz_k$(path).extensions_sh2glh_k$(extensions).nonStandardFields_tmp1ka_k$(nonStandardFields).build_1k0s4u_k$();
}
function readErrorLocations(_this__u8e3s4) {
  if (_this__u8e3s4.peek_21nx7_k$().equals(Token_NULL_getInstance())) {
    return _this__u8e3s4.nextNull_njy9ei_k$();
  }
  // Inline function 'kotlin.collections.mutableListOf' call
  var list = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  _this__u8e3s4.beginArray_hxn19s_k$();
  while (_this__u8e3s4.hasNext_bitz1p_k$()) {
    list.add_utx5q5_k$(readErrorLocation(_this__u8e3s4));
  }
  _this__u8e3s4.endArray_s2tmpq_k$();
  return list;
}
function readPath(_this__u8e3s4) {
  if (_this__u8e3s4.peek_21nx7_k$().equals(Token_NULL_getInstance())) {
    return _this__u8e3s4.nextNull_njy9ei_k$();
  }
  // Inline function 'kotlin.collections.mutableListOf' call
  var list = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  _this__u8e3s4.beginArray_hxn19s_k$();
  while (_this__u8e3s4.hasNext_bitz1p_k$()) {
    switch (_this__u8e3s4.peek_21nx7_k$().ordinal_1) {
      case 6:
      case 7:
        list.add_utx5q5_k$(_this__u8e3s4.nextInt_ujorgc_k$());
        break;
      default:
        list.add_utx5q5_k$(ensureNotNull(_this__u8e3s4.nextString_kwkc9o_k$()));
        break;
    }
  }
  _this__u8e3s4.endArray_s2tmpq_k$();
  return list;
}
function readErrorLocation(_this__u8e3s4) {
  var line = -1;
  var column = -1;
  _this__u8e3s4.beginObject_5wddq0_k$();
  while (_this__u8e3s4.hasNext_bitz1p_k$()) {
    switch (_this__u8e3s4.nextName_njxula_k$()) {
      case 'line':
        line = _this__u8e3s4.nextInt_ujorgc_k$();
        break;
      case 'column':
        column = _this__u8e3s4.nextInt_ujorgc_k$();
        break;
      default:
        _this__u8e3s4.skipValue_18u2ci_k$();
        break;
    }
  }
  _this__u8e3s4.endObject_ofuv3u_k$();
  return new (Location())(line, column);
}
//region block: init
ResponseParser_instance = new (ResponseParser())();
//endregion
//region block: exports
export {
  readErrors as readErrors1y0wtxnlur21l,
  ResponseParser_instance as ResponseParser_instance318qvs289p0qm,
};
//endregion

//# sourceMappingURL=ResponseParser.mjs.map
